// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1Mytk","cell":"ColumnAccessor_cell__339BK","firstCellAccent":"ColumnAccessor_firstCellAccent__2Vjsm"};